import { Button } from "react-md";
import React, { useState } from "react";
import { TextField, FormThemeProvider,Password } from "react-md";
import {  Button as BtnReact } from "reactstrap";
import { ContainerLogin, TextValidation } from "./styled.components";
import { useHistory } from "react-router-dom";
import { postLoginCandidato } from "../../requests/login";
import { getPerfil } from "../../requests/req_perfil";
import { amb } from "../../requests/utils";
import ClockLoader from "react-spinners/ClockLoader";

import ModalLogin from "./ModalResetPassword";

export const Login = () => {
  const history = useHistory();
  const [frmValues, setFrmValues] = React.useState({});
  const [infoCandidato, setInfoCandidato] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    correo:'',
    contrasenia:'',
    errors:''
  });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const validateEmail = () => {
    const { email} = frmValues;
    let regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return regex.test(String(email).toLowerCase());
  };

  const iniciarSesion = async () => {
    const { email, password } = frmValues;
    if (!validateEmail()) {
      setErrors({ ...errors, correo: "Ingrese un correo valido" });
      return;
    }
    if (!password) {
      setErrors({ ...errors, contrasenia: "Ingrese una contraseña" });
      return;
    }
    setIsLoading(true);   
    const data = await postLoginCandidato(email, password);
    if (Object.keys(data).length === 0) {
      setErrors({ ...errors, error: "Usuario y/o contraseña incorrecto" });
    }
    if (Object.keys(data).length !== 0) {
      setInfoCandidato(data);
      data.isCambio ? handleOpen() : procesoLogin(data);
    }
    setIsLoading(false);
  };

  const procesoLogin = (data) => {
    var bs64 = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
    sessionStorage.setItem(amb + "_User", bs64);
    localStorage.removeItem("foto");
    localStorage.setItem(
      "foto",
      data.foto
        ? data.foto
        : process.env.PUBLIC_URL + "/images/default-avatar.png"
    );
    //history.push("/perfil");
    getPerfil();
    console.log('Llegamos', data);

    window.location = "/perfil";
  };

  const enterPass = (e) => {
    if (e.key === "Enter") {
      var btn = document.getElementById("Frm_btn_Lgn");
      if (btn) btn.click();
    }
  };

  return (
    <>
      <ContainerLogin>
        <FormThemeProvider theme={"underline"}>
          <div className="ARC_Lgn_Frm">
            <div className="ARC_Lgn_Hd">Iniciar Sesión</div>
            <div className="container">
              <TextField
                onChange={(event) =>
                  setFrmValues({ ...frmValues, email: event.target.value })
                }
      
                id="IdUsuario"
                label="Correo electrónico"
                lineDirection="center"
                className="lg-cell lg-cell--bottom mt-4 mb-2"
              />
              {errors.correo?<TextValidation>{errors.correo}</TextValidation>:''}
              <Password
                onChange={(event) =>
                  setFrmValues({ ...frmValues, password: event.target.value })
                }
      
                id="IdPass"
                label="Contraseña"
                className="lg-cell lg-cell--bottom mt-2"
                onKeyUp={(e) => enterPass(e)}
              />
              {errors.contrasenia?<TextValidation>{errors.contrasenia}</TextValidation>:''}
              {errors.error?<TextValidation>{errors.error}</TextValidation>:''}
              <BtnReact
                color="secondary"
                onClick={() => history.push("/olvidada")}
                className="btn_no_decor"
              >
                ¿Olvidaste tu contraseña?
              </BtnReact>
              <br />
            </div>
            <div className="btn-iniciar">
              {isLoading ? (
                <ClockLoader color={"#f5a796"} size={30} />
              ) : (
                <Button
                  onClick={iniciarSesion}
                  floating
                  primary
                  className="frm_login_button"
                  id="Frm_btn_Lgn"
                >
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/icon_right_arrow_sml_w.png"
                    }
                    alt=" "
                  />
                </Button>
              )}
            </div>
          </div>
        </FormThemeProvider>
      </ContainerLogin>

      <ModalLogin
        infoCandidato={infoCandidato}
        procesoLogin={procesoLogin}
        handleClose={handleClose}
        handleOpen={handleOpen}
        open={open}
      />
    </>
  );
};
